import React from 'react';

import './Popup.css';

const Popup = ({ record, visible, coordinates }) =>
  visible && (
    <ul
      className="popup"
      style={{ left: `${coordinates.x}px`, top: `${coordinates.y}px` }}>
      <li>
        {/* <Icon type="user" /> */}
        {record.key}
      </li>
      <li>
        {/* <Icon type="heart-o" /> */}
        Like it
      </li>
      <li>
        {/* <Icon type="star-o" /> */}
        Bookmark
      </li>
    </ul>
  );

export default Popup;
